import React from 'react';

import { QueryRoute } from '@atlas/routing';

import ModalPortal from 'common/ModalPortal';
import StillHerePopup from 'src/terminal/popups/StillHerePopup';
import SignIn from 'src/terminal/popups/TerminalSigninPopup';
import TerminalWithdrawalPopup from 'src/terminal/popups/TerminalWithdrawalPopup';

const QueryRoutes = () => (
  <>
    <QueryRoute command="signin">
      <ModalPortal>
        <SignIn />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="signup">
      <ModalPortal>
        <SignIn isSignUp />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="stillHere">
      <ModalPortal>
        <StillHerePopup />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="withdrawal">
      <ModalPortal>
        <TerminalWithdrawalPopup />
      </ModalPortal>
    </QueryRoute>
  </>
);

export default QueryRoutes;
